export const HIGHLIGHT_RED = "#d53e4f";
export const NON_HIGHLIGHT_SALMON = "#c9a5aa";
export const UNDISPLAYED_BLUE = "#add8e6";
export const DISPLAYED_BLUE = "#4577b2";
